module.exports = __webpack_public_path__ + "img/x-men.55c6c309.svg";